module.exports = __webpack_public_path__ + "img/Logo-mobile.618d0df3.svg";